<!-- 
<div style="display: flex;align-items: center;margin-bottom: 1rem;"
     class="baslikMove">
    <img src="/simgeler/kumpas.webp"
         style="width: 22px !important;height: 22px;object-fit: contain;/*background-image:radial-gradient(circle closest-side,transparent,rgb(255 255 255 / 50%));*/">
    FikoYT Ölçüm

    <a class="ui circular icon label"
       (click)="kapa()"
       style="position: absolute;right:0.3rem;top:0.3rem;background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);">
        <i class="icon close"
           style="color:white;"></i>
    </a>
</div> -->

<!-- NOT: CATIA Ultra Minimal Toolbar -->
<div style="display: flex; gap: 1px; background: #34495e; padding: 2px; border-radius: 2px;">
    <button class="ui icon mini button"
            style="padding: 0.2rem; background: transparent; border: none; margin: 0;"
            [style.background]="olcumAleti=='Kumpas' ? '#FFD700' : 'transparent'"
            title="Measure Item"
            (click)="olcumAleti='Kumpas';CD.detectChanges();">
        <img src="/simgeler/kumpas.webp"
             style="width: 14px !important; height: 14px; object-fit: contain; opacity: 0.9;">
    </button>

    <button class="ui icon mini button"
            style="padding: 0.2rem; background: transparent; border: none; margin: 0;"
            [style.background]="olcumAleti=='Cetvel' ? '#FFD700' : 'transparent'"
            title="Measure Between"
            (click)="olcumAleti='Cetvel';CD.detectChanges();">
        <img src="/simgeler/cetvel.webp"
             style="width: 14px !important; height: 14px; object-fit: contain; opacity: 0.9;">
    </button>

    <button class="ui icon mini button"
            style="padding: 0.2rem; background: transparent; border: none; margin: 0; margin-left: auto;"
            [style.background]="olcumAleti=='Ayarlar' ? '#FFD700' : 'transparent'"
            title="Settings"
            (click)="olcumAleti='Ayarlar';CD.detectChanges();">
        <i class="icon cog"
           style="width: 14px !important; height: 14px; font-size: 12px; opacity: 0.9;"></i>
    </button>
</div>

<div class="ui divider"
     style="margin-top: 0.1rem;margin-bottom:0.1rem;"></div>

<!-- NOT:  Kumpas Modu -->
<fikoyt-kumpas #FikoYTKumpas
               [style.display]="olcumAleti=='Kumpas' ? 'block':'none'"
               [anaGosterim]="anaGosterim">
</fikoyt-kumpas>

<!-- NOT:  Cetvel Modu -->
<fikoyt-cetvel #FikoYTCetvel
               [style.display]="olcumAleti=='Cetvel' ? 'block':'none'"
               [anaGosterim]="anaGosterim">
</fikoyt-cetvel>

<!-- NOT:  Kalınlık Analizi Modu - KALDIRILDI -->

<!-- NOT:  Ayarlar Modu -->
<fikoyt-ayarlar #FikoYTAyarlar
                [style.display]="olcumAleti=='Ayarlar' ? 'block':'none'"
                [ayarlar]="ayarlar"
                (ayarlarDegisti)="kaydetAyarlar($event)">
</fikoyt-ayarlar>

<div class="ui divider"
     style="margin-top: 0.3rem;margin-bottom:0.3rem;"></div>

<div style="display: flex;align-items: center;">
    <input type="checkbox" name="checkbox" id="checkbox_id" value="value">
    <label for="checkbox_id">Ölçümler Kalıcı Olsun</label>
    <div class="ui animated mini button"
         tabindex="0"
         style="padding: 0.5rem;margin-left: auto;"
         (click)="kapa()">
        <div class="visible content">Kapat</div>
        <div class="hidden content">
            <i class="check icon"></i>
        </div>
    </div>
</div>
